"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Home: function() {
        return Home;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Home = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.3524 1.73803C11.7258 1.42062 12.2742 1.42062 12.6477 1.73803L22.6477 10.238C23.0685 10.5957 23.1196 11.2268 22.762 11.6476C22.4043 12.0684 21.7732 12.1196 21.3524 11.7619L21 11.4624V19C21 20.6568 19.6569 22 18 22H6.00002C4.34317 22 3.00002 20.6568 3.00002 19V11.4624L2.64767 11.7619C2.22686 12.1196 1.59577 12.0684 1.23808 11.6476C0.880394 11.2268 0.931564 10.5957 1.35237 10.238L11.3524 1.73803ZM5.00002 9.76241V19C5.00002 19.5523 5.44774 20 6.00002 20H18C18.5523 20 19 19.5523 19 19V9.76241L12 3.81241L5.00002 9.76241ZM12 12C10.8955 12 10 12.8954 10 14C10 15.1045 10.8955 16 12 16C13.1046 16 14 15.1045 14 14C14 12.8954 13.1046 12 12 12ZM16 14C16 11.7908 14.2092 9.99997 12 9.99997C9.79088 9.99997 8.00002 11.7908 8.00002 14C8.00002 16.2091 9.79088 18 12 18C14.2092 18 16 16.2091 16 14Z",
        fill: "currentColor"
    })
}), "Home");
const _default = Home;
